export default __webpack_public_path__ + "static/marker_eco-3aa8e51bd1b0a9f47bf16a88e3b412fb.svg";